import { MultiSelectActionsContainer } from 'src/components/common/MultiSelect/MultiSelectActionsContainer';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import { BroadcastActions } from './Actions/BroadcastActions';
import { CatchUpAction } from './Actions/CatchUpAction';
import { GroupActions } from './Actions/GroupActions';
import { PricingActions } from './Actions/PricingActions';
import { SettingsActions } from './Actions/SettingsActions';
import { TagsActions } from './Actions/TagsActions';

export const InventoryGlobalBulkActions = () => {
  const hasGroupListingsAcrossEventsFeature = useUserHasFeature(
    Feature.GroupListingsAcrossEvents
  );
  return (
    <MultiSelectActionsContainer>
      {hasGroupListingsAcrossEventsFeature && <GroupActions />}
      <PricingActions />
      <TagsActions />
      <BroadcastActions />
      <SettingsActions />
      <CatchUpAction />
    </MultiSelectActionsContainer>
  );
};
